import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { MedicalInsurance } from '../../../models/Entities/MedicalInsurances/MedicalInsurance';
import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import {
  Button,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerHeaderTitle,
  Label,
  MessageBar,
  MessageBarBody,
  OverlayDrawer,
  Spinner,
  Switch,
  Text
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';

////i18Next
import { useTranslation, Trans } from 'react-i18next';

// Store
import * as MedicalInsuranceStore from '../../../redux/middleware/MedicalInsuranceMiddleware';

//styles
import './MedicalInsuranceMultiSelectorComponent.css';
import { FontWeights } from '@fluentui/react';

export type SelectedMedicalInsuranceType = {
  medicalInsuranceId: number;
  ReferenceId: number;
};

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  SelectedMedicalInsurance: SelectedMedicalInsuranceType[];
  onSelect?: (medicalInsurance: MedicalInsurance) => void;
  onUnselect?: (medicalInsurance: SelectedMedicalInsuranceType) => void;
}

interface ConnectedProps {
  isLoading: boolean;
  loadingSuccess: boolean;
  failOnLoading: boolean;
  error: ErrorType;
  MedicalInsurances: MedicalInsurance[];
}

interface DispatchProps {
  GetAllMedicalInsurances: typeof MedicalInsuranceStore.actionCreators.GetAllMedicalInsurances;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const MedicalInsuranceMultiSelectorComponent = ({
  MedicalInsurances,
  isLoading,
  loadingSuccess,
  failOnLoading,
  error,
  SelectedMedicalInsurance,
  isOpen,
  openPanel: _openPanel,
  dismissPanel,
  onSelect,
  onUnselect,
  GetAllMedicalInsurances
}: Props) => {
  useEffect(() => {
    if (GetAllMedicalInsurances) GetAllMedicalInsurances(1, 200);
  }, [GetAllMedicalInsurances]);

  const HandleCancelForm = () => {
    dismissPanel();
  };

  const OnSelectMedicalInsurance = (medicalInsurance: MedicalInsurance) => {
    if (onSelect) onSelect(medicalInsurance);
  };

  //useTranslation()
  const [t] = useTranslation(); 
  const OnUnselectMedicalInsurance = (
    service: SelectedMedicalInsuranceType | undefined
  ) => {
    if (onUnselect && service) onUnselect(service);
  };

  const optionList = (
    <div className="MedicalInsuranceMultiSelectorContent">
      <MessageBar intent="warning">
        <MessageBarBody>
          {t('medicalInsuranceMultiSelector.message.medicalInsurance')}
          &nbsp;{SelectedMedicalInsurance.length}&nbsp;
          {t('medicalInsuranceMultiSelector.message.medicalInsuranceSelected')}
        </MessageBarBody>
      </MessageBar>

      <div className="SelectionMIListContainer">
        <div className="SelectionListRows">
          {MedicalInsurances &&
            MedicalInsurances.map((medicalInsurance: MedicalInsurance) => (
              <div key={medicalInsurance.id} className="SelectionListRow">
                <div className="SelectionList">
                  <Switch
                    checked={
                      SelectedMedicalInsurance.find(
                        (service: SelectedMedicalInsuranceType) =>
                          service.medicalInsuranceId === medicalInsurance.id
                      )
                        ? true
                        : false
                    }
                    onChange={(_, data) =>
                      data.checked
                        ? OnSelectMedicalInsurance(medicalInsurance)
                        : OnUnselectMedicalInsurance(
                            SelectedMedicalInsurance.find(
                              (service: SelectedMedicalInsuranceType) =>
                                service.medicalInsuranceId ===
                                medicalInsurance.id
                            )
                          )
                    }
                  />
                  <div className="SelectionList-item">
                    <Label style={{fontWeight: FontWeights.semibold}}>
                      {medicalInsurance.businessName}
                    </Label>
                    <Text>{medicalInsurance.title}</Text>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );

  // footer
  const onRenderFooterContent = () => (
    <DrawerFooter>
      <Button appearance="secondary" onClick={HandleCancelForm} className="OtherOption">
        <Trans i18nKey={'medicalInsuranceMultiSelector.footer.closeButton'} />
      </Button>
    </DrawerFooter>
  );

  return (
    <OverlayDrawer
      open={isOpen}
      onOpenChange={(_, data) => {
        if (!data.open) {
          dismissPanel();
        }
      }}
      position="end"
      size="medium"
    >
      <DrawerHeader>
        <DrawerHeaderTitle
          action={
            <Button
              appearance="subtle"
              icon={<Dismiss24Regular />}
              aria-label="Close popup modal"
              onClick={dismissPanel}
            />
          }
        >
          <Trans i18nKey={'medicalInsuranceMultiSelector.modal.medicalProviders'} />
        </DrawerHeaderTitle>
      </DrawerHeader>

      <DrawerBody className="MedicalInsuranceMultiSelectorBody">
        {failOnLoading && (
          <MessageBar intent="error">
            <MessageBarBody>{error?.ErrorMessage}</MessageBarBody>
          </MessageBar>
        )}

        {isLoading ? (
          <div>
            <Spinner label={t('medicalInsuranceMultiSelector.modal.loadingMedicalCoverage')} />
          </div>
        ) : (
          optionList
        )}
      </DrawerBody>

      {onRenderFooterContent()}
    </OverlayDrawer>
  );
};

const mapStateToProps = (state: AppState, ownprops: IProps) => ({
  isLoading: state.MedicalServices?.isLoadingAll,
  loadingSuccess: state.MedicalServices?.successLoadingAll,
  failOnLoading: state.MedicalServices?.failOnLoadingAll,
  error: state.MedicalServices?.error,
  MedicalInsurances: state.MedicalInsurances?.list
});

const mapDispatchToProps = {
  ...MedicalInsuranceStore.actionCreators
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MedicalInsuranceMultiSelectorComponent as any);
